export default function (routingAt: string) {
  const dayjs = useDayjs()
  const today = dayjs().format('YYYY-MM-DD')
  const routingAtDate = dayjs(routingAt);

  if (routingAtDate.startOf('day').diff(today, 'day') === 0) {
    return 'Aujourd\'hui à ' + routingAtDate.format('HH:mm');
  } else if (routingAtDate.startOf('day').diff(today, 'day') === 1) {
    return 'Demain à ' + routingAtDate.format('HH:mm');
  } else if (routingAtDate.startOf('day').diff(today, 'day') === -1) {
    return 'Hier à ' + routingAtDate.format('HH:mm')
  } else {
    return 'Le ' + useDayjsFormat(routingAt)
  }
}
